import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getInvoicesURL, getInvoiceURL } from '../api';
import moment from 'jalali-moment'

// initial state
export const initialState = {
  loading: false,
  error: false,
  currentPageIndex : 0,
  hasMore : true,
  items: [],
 
  fetchPermission : true,//برای مواقعی که بک زده میشه از یک فاکتور به فهرست نمیخواهیم مجدد لود شود

  selectedReturnedInvoice : {},
  selectedReturnedInvoiceId : '',

  searchKey : '',
  searchKey_fromdate : '',
  searchKey_todate : ''
};

// our slice
const returnedInvoiceSlice = createSlice({
  name: "ReturnedInvoice",
  initialState,
  reducers: {
    setReturnedInvoiceLoading: (state) => {
      state.loading = true;
    },
    setReturnedInvoiceSearchKey : (state, { payload }) =>{
      state.searchKey = payload;
    },
    setReturnedInvoiceSearchKeyFromdate : (state, { payload }) =>{
      state.searchKey_fromdate = payload;
    },
    setReturnedInvoiceSearchKeyTodate : (state, { payload }) =>{
      state.searchKey_todate = payload;
    },
    setReturnedInvoiceItems: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.items.push(...payload);
      if(payload.length === 0){
        state.hasMore = false;
      }
      console.log("newItems count is " + (payload.length));
      state.currentPageIndex++;
    },
    setSelectedReturnedInvoiceId: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      console.log("selectedReturnedInvoiceId");
      state.fetchPermission = false;// یعنی وارد یک فاکتور شدیم و دیگه مجدد لود نکنه اطلاعات رو
      state.selectedReturnedInvoiceId = payload;
    },
    setSelectedReturnedInvoice: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.selectedReturnedInvoice = payload;
      state.selectedReturnedInvoiceId = payload.ID;
      state.fetchPermission = false;
    },
    setReturnedInvoiceError: (state) => {
      state.error = true;
    },
    clearReturnedInvoiceItems: (state) => {
      state.items = [];
      state.currentPageIndex = 0;
      state.selectedReturnedInvoice = {};
      state.selectedReturnedInvoiceId = '';
    },
    clearSelectedReturnedInvoice: (state) => {
      state.selectedReturnedInvoice = {};
      state.selectedReturnedInvoiceId = '';
    },
    clearReturnedInvoiceFilters: (state) => {
      state.searchKey = '';
      state.searchKey_fromdate = '';
      state.searchKey_todate = '';
    },
    clearReturnedInvoiceData: (state) => {
      
      state.loading = false;
      state.error = false;
      state.currentPageIndex = 0;
      state.items = [];
      state.selectedReturnedInvoice = {};
      state.selectedReturnedInvoiceId = '';
      state.hasMore = true;
      state.searchKey  = '';
      state.searchKey_fromdate  = '';
      state.searchKey_todate  = '';
      state.fetchPermission = true;

    }
  },
});

// export the actions
export const { setReturnedInvoiceLoading, setReturnedInvoiceItems, setReturnedInvoiceError, clearReturnedInvoiceData,setReturnedInvoiceSearchKey, setReturnedInvoiceSearchKeyFromdate, setReturnedInvoiceSearchKeyTodate,clearReturnedInvoiceItems ,clearReturnedInvoiceFilters, setSelectedReturnedInvoice , setSelectedReturnedInvoiceId, clearSelectedReturnedInvoice} = returnedInvoiceSlice.actions;
  
// export the selector (".items" being same as in slices/index.js's "items: something")
export const returnedInvoiceItemsSelector = (state) => state.items;

// export the default reducer
export default returnedInvoiceSlice.reducer;


// fetch all items
export function fetchReturnedInvoices(input) {
  return async (dispatch) => {
    console.log("input");
console.log(input);

    var _fd = "";
    _fd = moment.from(input.fromdate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    
    var _td = "";
    _td = moment.from(input.todate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);

    if(input.pageindex === 0)
      dispatch(clearReturnedInvoiceItems());

    if(input.hasMore){
      dispatch(setReturnedInvoiceLoading());
      await axios.post(getInvoicesURL()+'?saleDocType=3&searchKey='+input.searchkey+'&searchNumber='+''+'&pageIndex='+input.pageindex+'&fromDate='+_fd+'&toDate='+_td+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setReturnedInvoiceItems(response.data));
      }).catch(function (err) {
        dispatch(setReturnedInvoiceError());
      }).finally(()=> {

      });
  }
  };
}


// fetch all items
export function fetchReturnedInvoice(input) {
  return async (dispatch) => {

      dispatch(setReturnedInvoiceLoading());
      await axios.post(getInvoiceURL()+'?saleDocType=3&saleDocId='+input.saleDocId+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setSelectedReturnedInvoice(response.data));
      }).catch(function (err) {
        dispatch(setReturnedInvoiceError());
      }).finally(()=> {

      });
  }
};

export function clearReturnedInvoice() {
  return async (dispatch) => {

      dispatch(clearReturnedInvoiceData());
   
  };
}